import React from "react";
import Paragraph from "components/elements/Paragraph";

type Props = {
    className?: string;
    children: any;
};

function LegalParagraph(props: Props) {

    return (
        <Paragraph className={`mb-3 ${props.className}`}>
            {props.children}
        </Paragraph>
    );
}

export default LegalParagraph;